<template>
	<div class="small-12 mainWrap home">
		<header-public/>
		<main class="small-12 columns">
			<index-feature/>
		</main>
		<site-footer/>
	</div>
</template>

<script>

	// Import the components
	import HeaderPublic from '@/components/framework/header/HeaderPublic.vue'
	import SiteFooter from '@/components/framework/footer/SiteFooter.vue'
	import IndexFeature from '@/components/index/IndexFeature.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'SiteIndex',

		/*
		**  Register the components
		*/

		components: {

		    HeaderPublic,
		    SiteFooter,
		    IndexFeature

		}

	}

</script>